import Vue from 'vue';

Vue.directive('focus', {
  // Когда привязанный элемент вставлен в DOM...
  inserted(el) {
    // Переключаем фокус на элемент
    el.focus();
  },
});
